class ApplicationState {
    name: string;
    windowState: MainWindowState;

    constructor(applicationStateName: string) {
        this.name = applicationStateName;
        this.windowState = new MainWindowState();
    }

    getWindowState() {
        return this.windowState;
    }
}